<template>
    <Typography
        is="div"
        type="paragraph"
        size="xs"
        :class="$style.seo_text"
    >
        <SeoTextRaw :content="props.text" />
    </Typography>
</template>
<script setup lang="ts">
import SeoTextRaw from '@/components/SeoText/SeoTextRaw.vue'
import Typography from '@/components/Typography.vue'

const props = defineProps<{
    text: string
}>()
</script>
<style module>
.seo_text {
    opacity: 0.8;
    overflow: hidden;
    mask-image: linear-gradient(black 0%, transparent 95%);
}

.seo_text h2,
.seo_text h3,
.seo_text h4 {
    font-size: inherit;
    margin-bottom: 4px;
}
</style>
